
import SEOHead from '../../components/seo/SEOHead';
import ConsultationHeroSection from './components/ConsultationHeroSection';
import ServicesSection from './components/ServicesSection';
import ExpertTeamSection from './components/ExpertTeamSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function Consultation() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "茶叶咨询服务",
    "description": "顺年陈提供专业的茶叶咨询服务，包括年份茶鉴定、收藏建议、品饮指导等专业服务。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/consultation`,
    "provider": {
      "@type": "Organization",
      "name": "顺年陈"
    },
    "serviceType": "茶叶咨询",
    "areaServed": "中国",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "咨询服务目录",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "年份茶鉴定"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "收藏建议"
          }
        }
      ]
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="茶叶咨询服务 - 顺年陈专业茶叶指导"
        description="顺年陈提供专业的茶叶咨询服务，包括年份茶鉴定、收藏建议、品饮指导等专业服务。资深茶师团队为您提供权威指导。"
        keywords="茶叶咨询,年份茶鉴定,收藏建议,品饮指导,茶叶专家,顺年陈咨询"
        canonical="/consultation"
        structuredData={structuredData}
      />
      <ConsultationHeroSection />
      <ServicesSection />
      <ExpertTeamSection />
      <FAQSection />
      <ContactSection />
    </div>
  );
}
